export default __webpack_public_path__ + "static/media/eliott2.9e07ae9d.jpg";